// React
import { createContext } from "react"

export const DisabledContext = createContext<boolean>(false)